import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Refreshes the page every few seconds. With turbo-refresh-method set to morph, only what
// changed is redrawn.
export default class extends Controller {
  static values = { seconds: { type: Number, default: 15 } }

  connect() {
    this.timer = setInterval(() => Turbo.visit(window.location.href, { action: "replace" }), this.secondsValue * 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
